import React from 'react';
import Section from '../layouts/Section';
import PageLayout from '../layouts/PageLayout';

const WarrantyPolicy = () => {
  return (
    <PageLayout title="Cell Station – Warranty Policy">
      <Section title="Warranty Policy">
        <div className="section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="policy-content" style={styles.content}>
                  <p style={styles.lastUpdated}>Last Updated: January 2025</p>

                  <div style={styles.warrantyBadge}>
                    <div style={styles.badgeIcon}>
                      <i className="fas fa-shield-alt"></i>
                    </div>
                    <div>
                      <h3 style={styles.badgeTitle}>Cell Station Quality Guarantee</h3>
                      <p style={styles.badgeText}>
                        We stand behind our work. All repairs come with a warranty to ensure your peace of mind.
                      </p>
                    </div>
                  </div>

                  {/* Repair Warranty Section */}
                  <div style={styles.section}>
                    <h3 style={styles.heading}>Repair Service Warranty</h3>

                    <div style={styles.warrantyGrid}>
                      <div style={styles.warrantyCard}>
                        <div style={styles.warrantyIcon}>
                          <i className="fas fa-mobile-alt"></i>
                        </div>
                        <h4 style={styles.warrantyTitle}>Screen Repairs</h4>
                        <p style={styles.warrantyPeriod}>30 Days</p>
                        <p style={styles.warrantyDesc}>
                          Covers display defects, touch sensitivity issues, and manufacturing defects in replacement screens
                        </p>
                      </div>

                      <div style={styles.warrantyCard}>
                        <div style={styles.warrantyIcon}>
                          <i className="fas fa-battery-full"></i>
                        </div>
                        <h4 style={styles.warrantyTitle}>Battery Replacement</h4>
                        <p style={styles.warrantyPeriod}>30 Days</p>
                        <p style={styles.warrantyDesc}>
                          Covers battery performance issues and defects. Battery health must remain above 80%
                        </p>
                      </div>

                      <div style={styles.warrantyCard}>
                        <div style={styles.warrantyIcon}>
                          <i className="fas fa-plug"></i>
                        </div>
                        <h4 style={styles.warrantyTitle}>Charging Port</h4>
                        <p style={styles.warrantyPeriod}>30 Days</p>
                        <p style={styles.warrantyDesc}>
                          Covers charging connectivity issues and port functionality defects
                        </p>
                      </div>

                      <div style={styles.warrantyCard}>
                        <div style={styles.warrantyIcon}>
                          <i className="fas fa-camera"></i>
                        </div>
                        <h4 style={styles.warrantyTitle}>Camera Repairs</h4>
                        <p style={styles.warrantyPeriod}>30 Days</p>
                        <p style={styles.warrantyDesc}>
                          Covers camera functionality, focus issues, and lens defects
                        </p>
                      </div>

                      <div style={styles.warrantyCard}>
                        <div style={styles.warrantyIcon}>
                          <i className="fas fa-volume-up"></i>
                        </div>
                        <h4 style={styles.warrantyTitle}>Speaker/Mic</h4>
                        <p style={styles.warrantyPeriod}>30 Days</p>
                        <p style={styles.warrantyDesc}>
                          Covers audio quality issues and microphone functionality
                        </p>
                      </div>

                      <div style={styles.warrantyCard}>
                        <div style={styles.warrantyIcon}>
                          <i className="fas fa-microchip"></i>
                        </div>
                        <h4 style={styles.warrantyTitle}>Other Parts</h4>
                        <p style={styles.warrantyPeriod}>30 Days</p>
                        <p style={styles.warrantyDesc}>
                          All replacement parts covered for defects and workmanship issues
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* What's Covered */}
                  <div style={styles.section}>
                    <h3 style={styles.heading}>What's Covered</h3>
                    <div style={styles.coverageBox}>
                      <div style={styles.coveredList}>
                        <h4 style={styles.listTitle}>
                          <i className="fas fa-check-circle" style={{ color: '#28a745', marginRight: '10px' }}></i>
                          Covered Under Warranty
                        </h4>
                        <ul style={styles.list}>
                          <li>Defective parts installed by Cell Station</li>
                          <li>Workmanship issues related to the repair</li>
                          <li>Part malfunctions under normal use</li>
                          <li>Issues directly related to the original repair</li>
                          <li>Manufacturing defects in replacement parts</li>
                        </ul>
                      </div>
                      <div style={styles.notCoveredList}>
                        <h4 style={styles.listTitle}>
                          <i className="fas fa-times-circle" style={{ color: '#dc3545', marginRight: '10px' }}></i>
                          Not Covered Under Warranty
                        </h4>
                        <ul style={styles.list}>
                          <li>Physical damage (drops, cracks, bends)</li>
                          <li>Liquid or water damage</li>
                          <li>Damage from unauthorized repairs</li>
                          <li>Software issues or iOS/Android updates</li>
                          <li>Normal wear and tear</li>
                          <li>Damage from misuse or neglect</li>
                          <li>Cosmetic damage that doesn't affect function</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Accessories Disclaimer */}
                  <div style={styles.section}>
                    <h3 style={styles.heading}>Accessories & Products</h3>
                    <div style={styles.noWarrantyBox}>
                      <i className="fas fa-info-circle" style={{ fontSize: '24px', marginBottom: '15px', color: '#F50963' }}></i>
                      <p style={styles.noWarrantyText}>
                        <strong>No Warranty on Accessories</strong>
                      </p>
                      <p style={styles.noWarrantyDesc}>
                        All accessory sales (cases, chargers, cables, screen protectors, etc.) are final.
                        Accessories and products do not include any warranty coverage. Please inspect all
                        items before leaving the store.
                      </p>
                    </div>
                  </div>

                  {/* Warranty Claim Process */}
                  <div style={styles.section}>
                    <h3 style={styles.heading}>How to Make a Warranty Claim</h3>
                    <div style={styles.claimSteps}>
                      <div style={styles.claimStep}>
                        <div style={styles.stepCircle}>1</div>
                        <h5 style={styles.stepTitle}>Bring Your Device</h5>
                        <p style={styles.stepDesc}>
                          Visit our store with your device and original repair receipt
                        </p>
                      </div>
                      <div style={styles.stepConnector}></div>
                      <div style={styles.claimStep}>
                        <div style={styles.stepCircle}>2</div>
                        <h5 style={styles.stepTitle}>Free Inspection</h5>
                        <p style={styles.stepDesc}>
                          Our technician will diagnose the issue and verify warranty eligibility
                        </p>
                      </div>
                      <div style={styles.stepConnector}></div>
                      <div style={styles.claimStep}>
                        <div style={styles.stepCircle}>3</div>
                        <h5 style={styles.stepTitle}>Repair or Replace</h5>
                        <p style={styles.stepDesc}>
                          If covered, we'll repair or replace the part at no additional cost
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Important Notes */}
                  <div style={styles.importantSection}>
                    <h3 style={styles.importantTitle}>
                      <i className="fas fa-exclamation-triangle" style={{ marginRight: '10px' }}></i>
                      Important Information
                    </h3>
                    <ul style={styles.importantList}>
                      <li>Original repair receipt is required for all warranty claims</li>
                      <li>Warranty is non-transferable and applies to original customer only</li>
                      <li>Opening or tampering with the device voids the warranty</li>
                      <li>Warranty period begins on the date of repair completion</li>
                      <li>Cell Station reserves the right to determine warranty eligibility</li>
                      <li>Warranty repairs may be completed with equivalent quality parts</li>
                    </ul>
                  </div>

                  <div style={styles.contactBox}>
                    <h4 style={styles.contactTitle}>Need Warranty Service?</h4>
                    <p style={styles.contactText}>
                      Bring your device and receipt to our store, or contact us first:
                    </p>
                    <div style={styles.contactGrid}>
                      <div>
                        <p style={styles.contactText}>
                          <i className="fas fa-phone" style={styles.icon}></i>
                          <a href="tel:+12159393933" style={styles.link}>+1 (215) 939-3933</a>
                        </p>
                        <p style={styles.contactText}>
                          <i className="fas fa-envelope" style={styles.icon}></i>
                          <a href="mailto:icellstation1@gmail.com" style={styles.link}>icellstation1@gmail.com</a>
                        </p>
                      </div>
                      <div>
                        <p style={styles.contactText}>
                          <i className="fas fa-map-marker-alt" style={styles.icon}></i>
                          <strong>Cell Station</strong><br />
                          2500 W Moreland Rd, Space #1077<br />
                          Willow Grove, PA 19090
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </PageLayout>
  );
};

const styles = {
  content: {
    backgroundColor: '#fff',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 5px 30px rgba(0,0,0,0.08)',
    marginBottom: '40px',
  },
  lastUpdated: {
    color: '#666',
    fontStyle: 'italic',
    marginBottom: '20px',
  },
  warrantyBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '25px',
    background: 'linear-gradient(135deg, #F50963 0%, #ff6b9d 100%)',
    padding: '30px',
    borderRadius: '16px',
    marginBottom: '40px',
    color: '#fff',
  },
  badgeIcon: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255,255,255,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '36px',
    flexShrink: 0,
  },
  badgeTitle: {
    color: '#fff',
    margin: '0 0 10px 0',
    fontSize: '24px',
  },
  badgeText: {
    color: 'rgba(255,255,255,0.9)',
    margin: 0,
    fontSize: '16px',
    lineHeight: '1.6',
  },
  section: {
    marginBottom: '40px',
  },
  heading: {
    color: '#1a1a2e',
    fontSize: '24px',
    fontWeight: '600',
    marginBottom: '25px',
    paddingBottom: '15px',
    borderBottom: '2px solid #f0f0f0',
  },
  warrantyGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '20px',
  },
  warrantyCard: {
    backgroundColor: '#f8f9fa',
    padding: '25px',
    borderRadius: '12px',
    textAlign: 'center',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },
  warrantyIcon: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: '#1a1a2e',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    margin: '0 auto 15px',
  },
  warrantyTitle: {
    color: '#1a1a2e',
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '10px',
  },
  warrantyPeriod: {
    color: '#F50963',
    fontSize: '24px',
    fontWeight: '700',
    marginBottom: '10px',
  },
  warrantyDesc: {
    color: '#666',
    fontSize: '14px',
    lineHeight: '1.6',
    margin: 0,
  },
  coverageBox: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '20px',
  },
  coveredList: {
    backgroundColor: '#f0fff4',
    padding: '25px',
    borderRadius: '12px',
    border: '1px solid #c3e6cb',
  },
  notCoveredList: {
    backgroundColor: '#fff5f5',
    padding: '25px',
    borderRadius: '12px',
    border: '1px solid #f5c6cb',
  },
  listTitle: {
    color: '#1a1a2e',
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '15px',
  },
  list: {
    color: '#555',
    lineHeight: '2',
    paddingLeft: '20px',
    margin: 0,
  },
  noWarrantyBox: {
    backgroundColor: '#f8f9fa',
    padding: '30px',
    borderRadius: '12px',
    textAlign: 'center',
    border: '2px dashed #ddd',
  },
  noWarrantyText: {
    color: '#1a1a2e',
    fontSize: '18px',
    marginBottom: '10px',
  },
  noWarrantyDesc: {
    color: '#666',
    fontSize: '15px',
    lineHeight: '1.7',
    margin: 0,
    maxWidth: '500px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  claimSteps: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '20px',
  },
  claimStep: {
    flex: '1',
    minWidth: '200px',
    textAlign: 'center',
  },
  stepCircle: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    backgroundColor: '#F50963',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    fontWeight: '600',
    margin: '0 auto 15px',
  },
  stepConnector: {
    width: '60px',
    height: '2px',
    backgroundColor: '#e0e0e0',
    alignSelf: 'center',
    marginTop: '-40px',
  },
  stepTitle: {
    color: '#1a1a2e',
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '10px',
  },
  stepDesc: {
    color: '#666',
    fontSize: '14px',
    lineHeight: '1.6',
    margin: 0,
  },
  importantSection: {
    backgroundColor: '#fff8e6',
    padding: '30px',
    borderRadius: '12px',
    border: '1px solid #f0e6cc',
    marginBottom: '40px',
  },
  importantTitle: {
    color: '#856404',
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '20px',
  },
  importantList: {
    color: '#856404',
    lineHeight: '2',
    paddingLeft: '20px',
    margin: 0,
  },
  contactBox: {
    backgroundColor: '#f8f9fa',
    padding: '30px',
    borderRadius: '10px',
    borderLeft: '4px solid #F50963',
  },
  contactTitle: {
    color: '#1a1a2e',
    marginBottom: '15px',
  },
  contactText: {
    color: '#555',
    marginBottom: '10px',
    lineHeight: '1.8',
  },
  contactGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
    marginTop: '20px',
  },
  link: {
    color: '#F50963',
    textDecoration: 'none',
  },
  icon: {
    color: '#F50963',
    marginRight: '10px',
    width: '20px',
  },
};

export default WarrantyPolicy;
